import * as api from "../tenvicCommon/API";
import Swal from "sweetalert2";
import Utils from "./Utils";

// User - Menus
export function UserMenus() {
    const userMenus = api.GetUserMenus;
    return fetch(userMenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message);
                return null;
            }
        })
}

// Verify reset password Token
export async function verifyToken(token: string) {
    const verify = api.ValidatePasswordToken + "/" + token;
    return fetch(verify, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            return result;
        })
}

// List Roles
export function listRoles() {
    const listRoles = api.RolesList;
    return fetch(listRoles, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message);
                return null;
            }
        })
}

// Get Roles
export function getRole(rowid: string) {
    const role = api.GetRole + '/' + rowid;
    return fetch(role, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List Permission
export function listPermission() {
    const listPermission = api.PermissionsList;
    return fetch(listPermission, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get Permissions
export function getPermission(rowid: string) {
    const permission = api.GetPermission + '/' + rowid;
    return fetch(permission, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List Roles Permissions
export function listRolesPermission() {
    const listRP = api.RolePermissionsList;
    return fetch(listRP, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get Roles Permissions
export function getRolePermission(rowid: string) {
    const rolePermision = api.GetRolePermission + '/' + rowid;
    return fetch(rolePermision, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List Menus
export function listMenus() {
    const listmenus = api.MenuList;
    return fetch(listmenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get Menu
export function getMenu(rowid: string) {
    const menu = api.GetMenu + '/' + rowid;
    return fetch(menu, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        },
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List Menu Roles
export function listMenuRole() {
    const listMenuRoles = api.MenuRoleList;
    return fetch(listMenuRoles, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get Menu Roles
export function getMenuRole(rowid: string) {
    const menurole = api.GetMenuRole + '/' + rowid;
    return fetch(menurole, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List Sub menus
export function listSubMenus() {
    const listSubMenus = api.SubMenuList;
    return fetch(listSubMenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get Submenu
export function getSubmenu(rowid: string) {
    const submenu = api.GetSubMenu + '/' + rowid;
    return fetch(submenu, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get SubMenu by menu id
export function getSubmenusByMenu(mnuid: string) {
    const mnusubmenu = api.GetSubMenuByMenu + '/' + mnuid;
    return fetch(mnusubmenu, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List User RBAC
export function listUserRBAC() {
    const listUser = api.ListUserRBAC;
    return fetch(listUser, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get User RBAC
export function getUserRBAC(rowid: string) {
    const getUsr = api.GetUserRBAC + '/' + rowid;
    return fetch(getUsr, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// list users
export function listUsers() {
    const listUsers = api.ListUsers;
    return fetch(listUsers, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}


// Get Users
export function getUser(rowid: string) {
    const getUsr = api.GetUser + '/' + rowid;
    return fetch(getUsr, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// List Clients
export function listClients() {
    const clientmenus = api.ClientList;
    return fetch(clientmenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// Get Client
export function getClient(rowid: string) {
    const client = api.GetClient + '/' + rowid;
    return fetch(client, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        },
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}

// logout
export function logout() {
    const lgout = api.TenvicLogout;
    return fetch(lgout, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                Swal.fire(result.message)
            }
        })
}